window.ViewMode = new function()
{
    this.init = function() {
        jQuery('.change-view-mode').click(function(event) {
            var view_mode = jQuery(this).data('view-mode');

            ViewMode.setCookie('fun_view_mode', view_mode, 30);

            if(view_mode == 'masonry' || jQuery('body').hasClass('view_mode_masonry')) {
                location.reload();
                return false;
            }

            jQuery('.change-view-mode').removeClass('active');
            jQuery(this).addClass('active');
            
            jQuery('body').removeClass('view_mode_full');
            jQuery('body').removeClass('view_mode_condensed');
            jQuery('body').removeClass('view_mode_titles');
            
            jQuery('body').addClass('view_mode_' + view_mode);

            jQuery('.mbl-view-mode-trigger i').attr('class', '');
            if(view_mode == 'full') {
                jQuery('.mbl-view-mode-trigger i').addClass('fa-solid fa-chart-tree-map');
                jQuery('.view-mode-wrap').removeClass('visible');

                //Post Sliders
                jQuery('.post-media.multiple').each(function(){
                    jQuery(this).slick('unslick');
                    jQuery(this).slick({
                        lazyLoad: 'progressive',
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        fade:true,
                        arrows: true,
                        dots: true,
                        prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
                        nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>'
                    });
                });

            } else if(view_mode == 'condensed') {
                jQuery('.mbl-view-mode-trigger i').addClass('fa-solid fa-list');
                jQuery('.view-mode-wrap').removeClass('visible');
            } else if(view_mode == 'titles') {
                jQuery('.mbl-view-mode-trigger i').addClass('fa-solid fa-grip-lines');
                jQuery('.view-mode-wrap').removeClass('visible');
            }
        });

        jQuery('html').click(function(e) {
            if(!jQuery(e.target).closest(".view-mode").length) {
                jQuery('.view-mode-wrap').addClass('sm-hide');
            }
        });

        jQuery('.mbl-view-mode-trigger').click(function(e) {
            jQuery('.view-mode-wrap').toggleClass('visible');
        });

        if(jQuery('body').hasClass('post_view')) {
            jQuery('body').removeClass('view_mode_full');
            jQuery('body').removeClass('view_mode_condensed');
            jQuery('body').removeClass('view_mode_titles');
            jQuery('body').removeClass('view_mode_masonry');
        }

        jQuery('body').on('click', '.post-card .expand-card', function(event) {
            event.preventDefault();
            jQuery(this).closest('.post-card').toggleClass('expanded');
        });
    };

    /**
     * Sets a cookie via JS
     *
     * @param string cname - Cookie Name
     * @param string|int cvalue - The value you're setting the cookie to
     * @param int exdays - The amount of days it takes the cookie to expire
     */
    this.setCookie = function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
}

jQuery(document).ready(function($) {
    ViewMode.init();
});

window.onload = function() {
    // Check if all images are loaded
    if (document.readyState === 'complete') {
        if(jQuery('body').hasClass('view_mode_masonry')) {
            jQuery('body').imagesLoaded( function() {
                jQuery('.post-list').isotope({
                  // options
                  itemSelector: '.post-card-wrap',
                  layoutMode: 'masonry'
                });
            });
        }
    }
};
